/**
 * User authority constants
 * Defines permission levels for admin and finance features
 */

export const authorities = {
  ADMIN_TOOL_AUTHORITY: 'ADMIN_TOOL_AUTHORITY',
  ADMIN_TOOL_SPECIAL_AUTHORITY: 'ADMIN_TOOL_SPECIAL_AUTHORITY',
  ADMIN_TOOL_LIMITED_AUTHORITY: 'ADMIN_TOOL_LIMITED_AUTHORITY',
  FINANCE_AUTHORITY: 'FINANCE_AUTHORITY',
} as const

/** Union type of all authority keys */
export type AuthorityKey = keyof typeof authorities

/** Union type of all authority values */
export type AuthorityValue = typeof authorities[AuthorityKey]

/**
 * Type guard to check if a string is a valid authority
 */
export function isAuthority(value: string): value is AuthorityValue {
  return Object.values(authorities).includes(value as AuthorityValue)
}